import { createContext } from 'react'

import type { AgGridContextValue } from '@/components/lemmala-design-system/table/types'

export const AgGridContext = createContext<AgGridContextValue | null>(null)
